import React from 'react';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';

import { BrandForm } from 'forms';

import { Modal } from 'components';

type Props = {
  visible?: boolean;
} & RouteComponentProps;

const ModalComponent: React.FC<Props> = () => {
  return (
    <Modal title="Add Brands" name="cb">
      <BrandForm />
    </Modal>
  );
};

export default withRouter(ModalComponent);
